var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',[_vm._v("Started 上手")]),_vm._v(" "),_c('h3',[_vm._v("引入 vue-form-layer")]),_vm._v(" "),_c('vue-markdown',{directives:[{name:"highlight",rawName:"v-highlight"}],attrs:{"source":_vm.content}}),_vm._v(" "),_c('h3',[_vm._v("开始使用")]),_vm._v(" "),_c('p',[_vm._v("现在就可以编写代码了。")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7da35d64","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/pages/started.vue
// module id = null
// module chunks = 